// extracted by mini-css-extract-plugin
module.exports = {"premium-badge":"styles-m__premium-badge__2cR3M"};